























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MomentOwned } from '@/MomentOwned'
import { Auction, auctionStatus } from '@/Auction'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'MomentOwnedListComponent',
  components: { Plotly, ModalWrapperComponent }
})
export default class MomentOwnedListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: MomentOwned

  @Prop({ default: true })
  public showCS: boolean

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop({ default: false })
  public isSignedInUser: boolean

  // public reactive member variables available to the html template
  public SHOW_IMAGE = true
  public SHOW_AUCTIONS = false

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public getNicePossibleDecimalPriceString(number): string { return utils_topshot.getNicePossibleDecimalPriceString(number)}
  public getNicePossibleDecimalPriceStringForFMV(number): string { return utils_topshot.getNicePossibleDecimalPriceStringForFMV(number)}  
  
  public showLedger(momentID: number, serial: number) {
    (this.$refs.MomentActivityFeedComponent as ModalWrapperComponent).show(`⏳ Serial #${serial} Timeline`, 'lg', { momentID: momentID })
  }

  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }

  public onAuctionButtonPressed() {
    const buttonName: string = this.getAuctionButtonName()
    if (buttonName === 'Post' || buttonName === 'Re-Post') {
      this.$emit('clicked-create-auction', this.moment)
      return
    }
    
    // view existing auction if 'Ongoing' or 'Ended'
    this.$emit('clicked-view-auction', this.moment)
  }

  public getAuctionButtonName(): string {
    if (!this.moment.auction) return 'Post'
    if (this.moment.auction.status === auctionStatus.Canceled) return 'Post'
    if (this.moment.auction.status === auctionStatus.Open) return 'Ongoing'
    if (this.moment.auction.status === auctionStatus.Ended && this.moment.auction.numBids > 0) return 'Ended'
    if (this.moment.auction.status === auctionStatus.Ended && this.moment.auction.numBids === 0) return 'Re-Post'   // TODO: consider showing Ended in red for a day after ending unsuccessfully
  }

  public getAuctionButtonVariant(): string {
    const buttonName: string = this.getAuctionButtonName()
    if (buttonName === 'Post' || buttonName === 'Re-Post') return 'info'
    if (buttonName === 'Ongoing') return 'warning'
    if (buttonName === 'Ended') {
      if (this.moment.auction.numBids > 0) return 'success'
      return 'danger'
    }

  }

  public getAuctionButtonPopupText(): string {
    if (!this.moment.auction) return null
    if (this.moment.auction.status === auctionStatus.Canceled) return 'Previous auction was canceled'
    if (this.moment.auction.status === auctionStatus.Open) return `${this.moment.auction.numBids} bid${ this.moment.auction.numBids === 1 ? '' : 's'} so far`
    if (this.moment.auction.status === auctionStatus.Ended && this.moment.auction.numBids > 0) return `${this.moment.auction.numBids} bid${ this.moment.auction.numBids === 1 ? '' : 's'} in the end`
    if (this.moment.auction.status === auctionStatus.Ended && this.moment.auction.numBids === 0) return 'Previous auction ended with 0 bids'
    return null
  }  

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
